import gql from 'graphql-tag';

import { executeGqlQuery, type GqlQueryOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendProject,
  BackendProjectLongFormBuilderOutlineSectionsArgs,
  BackendQueryProjectArgs,
} from 'src/types/backend';

import { FRAGMENT_PROJECT_LONG_FORM_SECTION } from './schema';

const QUERY = gql`
  query LongFormDraftSections($projectId: Int!, $draftIndex: ID) {
    project(id: $projectId) {
      longFormBuilderOutlineSections(longFormBuilderDraftId: $draftIndex) {
        ...LongFormSection
      }
    }
  }
  ${FRAGMENT_PROJECT_LONG_FORM_SECTION}
`;

type Variables = {
  projectId: BackendQueryProjectArgs['id'];
  draftIndex?: BackendProjectLongFormBuilderOutlineSectionsArgs['longFormBuilderDraftId'];
};

export const queryLongFormDraftSections = async (
  variables: Variables,
  options?: Pick<GqlQueryOptions, 'abortSignal'>
) => {
  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      abortSignal: options?.abortSignal,
    },
  });
  const data = getSingleProp<BackendProject>(response.data);
  return data?.longFormBuilderOutlineSections ?? [];
};
